export default "__VITE_ASSET__DsY0ad4t__"